import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import '../assets/css/gallery.css';

import slideshow01 from '../assets/images/slideshow-01.jpg';
import slideshow02 from '../assets/images/slideshow-02.jpg';
import slideshow03 from '../assets/images/slideshow-03.jpg';
import slideshow04 from '../assets/images/slideshow-04.jpg';
import slideshow05 from '../assets/images/slideshow-05.jpg';
import slideshow06 from '../assets/images/slideshow-06.jpg';
import slideshow007 from '../assets/images/slideshow-007.jpg';
import slideshow008 from '../assets/images/slideshow-008.jpg';
import slideshow009 from '../assets/images/slideshow-009.jpg';
import slideshow010 from '../assets/images/slideshow-010.jpg';
import slideshow011 from '../assets/images/slideshow-011.jpg';
import slideshow012 from '../assets/images/slideshow-012.jpg';
import slideshow013 from '../assets/images/slideshow-013.jpg';
import slideshow014 from '../assets/images/slideshow-014.jpg';
import slideshow016 from '../assets/images/slideshow-016.jpg';
import slideshow017 from '../assets/images/slideshow-017.jpg';
import slideshow018 from '../assets/images/slideshow-018.jpg';
import slideshow019 from '../assets/images/slideshow-019.jpg';
import slideshow020 from '../assets/images/slideshow-020.jpg';
import slideshow021 from '../assets/images/slideshow-021.jpg';
import slideshow022 from '../assets/images/slideshow-022.jpg';
import slideshow023 from '../assets/images/slideshow-023.jpg';
import slideshow024 from '../assets/images/slideshow-024.jpg';
import slideshow025 from '../assets/images/slideshow-025.jpg';
import slideshow026 from '../assets/images/slideshow-026.jpg';
import slideshow027 from '../assets/images/slideshow-027.jpg';
import slideshow028 from '../assets/images/slideshow-028.jpg';
import slideshow029 from '../assets/images/slideshow-029.jpg';
import slideshow030 from '../assets/images/slideshow-030.jpg';
import { getGalleryImageSources } from '../assets/images/responsiveImages';

const galleryImage = (name, fallback) => ({
  fallback,
  ...getGalleryImageSources(name),
});

const galleryImages = [
  galleryImage('slideshow-007', slideshow007),
  galleryImage('slideshow-008', slideshow008),
  galleryImage('slideshow-009', slideshow009),
  galleryImage('slideshow-010', slideshow010),
  galleryImage('slideshow-011', slideshow011),
  galleryImage('slideshow-012', slideshow012),
  galleryImage('slideshow-013', slideshow013),
  galleryImage('slideshow-014', slideshow014),
  galleryImage('slideshow-016', slideshow016),
  galleryImage('slideshow-017', slideshow017),
  galleryImage('slideshow-018', slideshow018),
  galleryImage('slideshow-019', slideshow019),
  galleryImage('slideshow-020', slideshow020),
  galleryImage('slideshow-021', slideshow021),
  galleryImage('slideshow-022', slideshow022),
  galleryImage('slideshow-023', slideshow023),
  galleryImage('slideshow-024', slideshow024),
  galleryImage('slideshow-025', slideshow025),
  galleryImage('slideshow-026', slideshow026),
  galleryImage('slideshow-027', slideshow027),
  galleryImage('slideshow-028', slideshow028),
  galleryImage('slideshow-029', slideshow029),
  galleryImage('slideshow-030', slideshow030),
  galleryImage('slideshow-01', slideshow01),
  galleryImage('slideshow-02', slideshow02),
  galleryImage('slideshow-03', slideshow03),
  galleryImage('slideshow-04', slideshow04),
  galleryImage('slideshow-05', slideshow05),
  galleryImage('slideshow-06', slideshow06),
];

const GallerySection = () => {
  const [thumbnailsSwiper, setThumbnailsSwiper] = useState(null);
  const activeThumbnailsSwiper = thumbnailsSwiper && !thumbnailsSwiper.destroyed
    ? thumbnailsSwiper
    : null;

  return (
    <section id="gallery" className="gallery-section section-breakpoint">
      <div className="container">
        <div className="gallery-layout">
          <Swiper
            className="gallery-thumbnails"
            modules={[FreeMode, Thumbs]}
            onSwiper={setThumbnailsSwiper}
            slidesPerView="auto"
            spaceBetween={10}
            freeMode={{ enabled: true, momentum: true }}
            grabCursor
            watchSlidesProgress
          >
            {galleryImages.map((image, index) => (
              <SwiperSlide className="gallery-thumb" key={image.fallback}>
                <picture>
                  <source type="image/webp" srcSet={image.thumbnail} />
                  <img
                    src={image.fallback}
                    alt={`Gallery ${index + 1}`}
                    loading="lazy"
                    decoding="async"
                    draggable="false"
                  />
                </picture>
              </SwiperSlide>
            ))}
          </Swiper>

          <Swiper
            className="gallery-main"
            modules={[Thumbs]}
            thumbs={{ swiper: activeThumbnailsSwiper }}
            grabCursor
            spaceBetween={10}
          >
            {galleryImages.map((image, index) => (
              <SwiperSlide key={image.fallback}>
                <picture>
                  <source
                    type="image/webp"
                    srcSet={`${image.thumbnail} 480w, ${image.medium} 960w, ${image.mediumLarge} 1280w, ${image.desktop} 1600w, ${image.large} ${image.largeWidth}w`}
                    sizes="100vw"
                  />
                  <img
                    src={image.fallback}
                    alt={`Gallery ${index + 1}`}
                    loading="lazy"
                    decoding="async"
                    draggable="false"
                  />
                </picture>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
